module.exports = __webpack_public_path__ + "static/media/tr808_snare_14.51fed667.wav";